document.addEventListener('DOMContentLoaded', function () {

    var isFlickity = false;

    screenchange();

    function screenchange()
    {
        if($(window).width() > 749)
        {
            if(!isFlickity)
            {
                $('.sc-thumbnail-slider').flickity({
                    asNavFor: '.product__media-list', contain: true, pageDots: false, groupCells: 3
                });

                $('.product__media-list').flickity({
                    contain: true,prevNextButtons: false,adaptiveHeight: true
                });
            }
            isFlickity = true;
        }else
        {
            if(isFlickity)
            {
                isFlickity = false;
                $('.sc-thumbnail-slider').flickity('destroy');
                $('.product__media-list').flickity('destroy');
            }
        }
    }
    $(window).on('resize',function(e){
        screenchange();
    });


    $('.rating-star').on('click',function(e){
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(".okeReviews").offset().top - 250
        }, 1000);


    });

});
